import setStatus from './status';

const initHeroCard = () => {
  // Define variables
  const heroCards: NodeListOf<HTMLElement> = document.querySelectorAll('.hero-card');

  // Functions
  const activeHero = (card) => {
    const cardEle = card;
    cardEle.classList.add('hero-card--active');
  };

  const removeAllActives = () => {
    [...heroCards].forEach((card) => {
      card.classList.remove('hero-card--active');
    });
  };

  // Loop thourh all the hero cards
  [...heroCards].forEach((card) => {
    card.addEventListener('click', () => {
      removeAllActives();
      activeHero(card);

      // Set status
      setStatus(card);
    });
  });
};

export default initHeroCard;
